import { FunctionComponent } from 'react'
import { Text } from '@conexasaude/conexa-hero'
import useStyles from './styles'

const TermsRefused: FunctionComponent = () => {
  const styles = useStyles()

  return (
    <div css={styles.termsContainer}>
      <Text renderAs="h2">
        Para realizar consultas é necessário aceitar os termos de uso. Em caso
        de dúvidas, entre em contato com a operadora.
      </Text>
    </div>
  )
}

export default TermsRefused
